import React, { useEffect, useRef } from 'react';
import SnakeGame from './logic';
import './style.css';

const SnakeGameComponent = () => {
    const canvasRef = useRef(null);
    const gameRef = useRef(null);

    useEffect(() => {
        console.log('SnakeGame component mounted');
        gameRef.current = new SnakeGame();
        gameRef.current.startGame();

        return () => {
            if (gameRef.current && gameRef.current.gameLoop) {
                clearInterval(gameRef.current.gameLoop);
            }
        };
    }, []);

    useEffect(() => {
        // Debug: Check if controls are visible
        const controls = document.querySelector('.controls');
        if (controls) {
            console.log('Controls element found:', controls);
            console.log('Controls display:', window.getComputedStyle(controls).display);
        }
    }, []);

    const handleButtonDirection = (dx, dy) => {
        if (gameRef.current) {
            if (dx !== -gameRef.current.dx) {
                gameRef.current.dx = dx;
                gameRef.current.dy = dy;
            }
        }
    };

    return (
        <div className="game-container">
            <h1>Snake Game</h1>
            <canvas
                ref={canvasRef}
                id="gameCanvas"
                width="405"
                height="405"
            />
            {/* Mobile Controls */}
            <div className="controls" style={{ display: 'flex' }}>
                <button
                    onClick={() => handleButtonDirection(0, -1)}
                    onTouchStart={(e) => {
                        e.preventDefault();
                        handleButtonDirection(0, -1);
                    }}
                    type="button"
                >
                    ↑
                </button>
                <div>
                    <button
                        onClick={() => handleButtonDirection(-1, 0)}
                        onTouchStart={(e) => {
                            e.preventDefault();
                            handleButtonDirection(-1, 0);
                        }}
                        type="button"
                    >
                        ←
                    </button>
                    <button
                        onClick={() => handleButtonDirection(1, 0)}
                        onTouchStart={(e) => {
                            e.preventDefault();
                            handleButtonDirection(1, 0);
                        }}
                        type="button"
                    >
                        →
                    </button>
                </div>
                <button
                    onClick={() => handleButtonDirection(0, 1)}
                    onTouchStart={(e) => {
                        e.preventDefault();
                        handleButtonDirection(0, 1);
                    }}
                    type="button"
                >
                    ↓
                </button>
            </div>
            <div className="instructions">
                <p>Use arrow keys or swipe on desktop, buttons on mobile</p>
                <p>Avoid red obstacles and eat pulsing food!</p>
            </div>
        </div>
    );
};

export default SnakeGameComponent;